<template>
  <div class="wrapper">
    <img class="topImg"
         :src="require('@/assets/images/企业动态banner.png')" />
    <div class="centerBox">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/enterprise' }">企业动态</el-breadcrumb-item>
        <el-breadcrumb-item>企业动态详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="title">{{ current.title }}</div>
      <div class="subheading">
        <span>{{ current.releaseTime }}</span>
        <span>来源：{{ current.dynamicSource }}</span>
      </div>

      <div class="center"
           v-html="current.businessContent"></div>

      <div class="pageBox">
        <div class="upBox"
             v-if="previous.title"
             @click="skip(previous)">
          <span>上一篇</span>
          <span>{{ previous.title }}</span>
        </div>
        <div class="downBox"
             v-if="next.title"
             @click="skip(next)">
          <span>下一篇</span>
          <span>{{ next.title }}</span>
        </div>
      </div>

      <div class="recommendBox">
        <div class="recommendTitle">为你推荐</div>
        <div v-for="(item, i) in businessList"
             :key="i"
             class="recommendItem"
             @click="skip(item)">
          {{ item.title }}
        </div>

        <div class="recommendMore"
             @click="moreFn">查看更多新闻 ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryBusiness, getUpDown } from "./server";
import { getBusiness } from "@/views/Enterprise/server";
export default {
  data () {
    return {
      current: {},
      next: {},
      previous: {},
      pageNum: 1,
      pageSize: 3,
      businessList: [],
    };
  },
  wathc: {},
  created () {
    this.init();
  },
  methods: {
    init () {
      queryBusiness(this.$route.query.id).then((res) => {
        this.current = res.data;

        getUpDown({
          releaseTime: this.current.releaseTime,
          businessId: this.$route.query.id,
        }).then((res) => {
          this.next = res.data.next || {};
          this.previous = res.data.previous || {};
        });
      });

      getBusiness({
        t: {
          publishStatus: "1",
          businessClassify: "1",
        },
        p: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        },
      }).then((res) => {
        this.businessList = res.rows;
      });
    },
    skip (row) {
      this.$router.push(`/detail?id=${row.businessId}`);
      location.reload();
    },
    moreFn () {
      this.$router.push(`/enterprise`);
    },
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.topImg {
  width: 100%;
}
@media (min-width: 1024px) {
  .centerBox {
    width: 100%;
    padding: 90px 624px 90px 319px;
    text-align: start;
    overflow: hidden;
    position: relative;
    .title {
      margin-top: 67px;
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #4a4a4a;
      text-align: start;
    }
    .subheading {
      margin-top: 39px;
      text-align: start;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #3f3f3f;
      > :last-child {
        margin-left: 32px;
      }
    }
    .center {
      width: 100%;
      overflow: hidden;
      margin-top: 94px;
      border-bottom: 1px solid #e1e1e1;
      ::v-deep img {
        width: 100% !important;
      }
    }
    .recommendBox {
      width: 274px;
      padding: 45px;
      position: absolute;
      top: 90px;
      right: 290px;
      background: rgba(247, 250, 255, 0);
      box-shadow: 0px 2px 16px 0px rgba(158, 158, 158, 0.15);
      border-radius: 8px;
      .recommendTitle {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #4a4a4a;
      }
      .recommendItem {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #434343;
        margin-top: 25px;
        padding-bottom: 44px;
        border-bottom: 1px solid #eee;
        cursor: pointer;
      }
      .recommendMore {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #a5a5a5;
        cursor: pointer;
        text-align: center;
        margin-top: 62px;
      }
    }
    .pageBox {
      margin-top: 30px;

      .upBox,
      .downBox {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #434343;
        cursor: pointer;
        > :last-child {
          margin-left: 20px;
          font-size: 22px;
        }
        > :first-child {
          font-weight: bold;
        }
        :hover {
          text-decoration: underline;
        }
      }
      > .downBox {
        margin-top: 20px;
      }
    }
  }
}

@media (max-width: 1024px) {
  .centerBox {
    width: 100%;
    padding: 20px 120px 20px 10px;
    text-align: start;
    overflow: hidden;
    position: relative;
    .title {
      margin-top: 17px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #4a4a4a;
      text-align: start;
    }
    .subheading {
      margin-top: 10px;
      text-align: start;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #3f3f3f;
      > :last-child {
        margin-left: 12px;
      }
    }
    .center {
      width: 100%;
      overflow: hidden;
      margin-top: 94px;
      border-bottom: 1px solid #e1e1e1;
      ::v-deep img {
        width: 100% !important;
      }
    }
    .recommendBox {
      width: 100px;
      padding: 15px;
      position: absolute;
      top: 0;
      right: 10px;
      background: rgba(247, 250, 255, 0);
      box-shadow: 0px 2px 16px 0px rgba(158, 158, 158, 0.15);
      border-radius: 8px;
      .recommendTitle {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #4a4a4a;
      }
      .recommendItem {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #434343;
        margin-top: 15px;
        cursor: pointer;
      }
      .recommendMore {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #a5a5a5;
        cursor: pointer;
        text-align: center;
        margin-top: 12px;
      }
    }
    .pageBox {
      margin-top: 20px;

      .upBox,
      .downBox {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #434343;
        cursor: pointer;
        > :last-child {
          margin-left: 5px;
          font-size: 12px;
        }
        > :first-child {
          font-weight: bold;
        }
        :hover {
          text-decoration: underline;
        }
      }
      > .downBox {
        margin-top: 20px;
      }
    }
  }
}
</style>
